import React from "react";
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer } from "recharts";
import { hiringTrendsData } from "./config/dashboardConfig";

const HiringTrends: React.FC = () => {
  return (
    <div className="bg-white rounded-xl shadow-md p-4">
      <h2 className="text-lg font-semibold mb-4">Hiring Trends</h2>
      <div className="w-full" style={{ height: 250 }}>  {/* set a fixed chart height only */}
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={hiringTrendsData}>
            <XAxis dataKey="month" />
            <YAxis />
            <Tooltip />
            <Line type="monotone" dataKey="value" stroke="#1677ff" strokeWidth={2} dot />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default HiringTrends;
